import React from 'react';
import { Table, Segment } from 'semantic-ui-react';
import apiService from '../../../../service/apiService';
import readingsParser from './lib/readingViewFSM';

class ReadingsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: [],
      valueStr: '',
    };
  }

  async componentDidMount() {
    // make api call here
    console.log('mounted readings');
    const { taskId, assetId } = this?.props || {};
    if (taskId && assetId) {
      const apiResponse = await apiService.getReadingData({ taskId, assetId });
      const response = readingsParser(apiResponse);
      console.log(response);
      if (response?.valueStr && response?.order && response?.order?.length) {
        const { order, valueStr } = response;
        this.setState({ order, valueStr });
      }
    }
  }

  render() {
    const { order, valueStr } = this.state;

    return (
      <Segment style={{ border: '1px solid #e5e5e5', marginTop: '0px' }}>
        {order && valueStr && (
          <>
            <div> Reading Data</div>
            <Table celled fixed singleLine>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Name</Table.HeaderCell>
                  <Table.HeaderCell>Value</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {order.map(({ name, displayName }) => {
                  return (
                    <Table.Row>
                      <Table.Cell>{displayName}</Table.Cell>
                      <Table.Cell>{valueStr[name]}</Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
            <br />
          </>
        )}
        {!(order && valueStr) && <div>Reading not yet available</div>}
      </Segment>
    );
  }
}

export default ReadingsComponent;
